import { hotRank } from "@/mocks/gossip";

const maxHeat = Math.max(...hotRank.map((h) => h.heat));

function Trend({ delta }: { delta: string }) {
  if (delta === "new")
    return (
      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-2 py-0.5 text-[10px] font-medium text-background-50">
        新晋
      </span>
    );
  if (delta === "up")
    return (
      <span className="inline-flex items-center gap-0.5 text-accent-600">
        <i className="ri-arrow-up-line text-xs"></i>
        <span className="text-[11px]">上升</span>
      </span>
    );
  if (delta === "down")
    return (
      <span className="inline-flex items-center gap-0.5 text-foreground-400">
        <i className="ri-arrow-down-line text-xs"></i>
        <span className="text-[11px]">回落</span>
      </span>
    );
  return (
    <span className="inline-flex items-center gap-0.5 text-foreground-400">
      <i className="ri-subtract-line text-xs"></i>
      <span className="text-[11px]">持平</span>
    </span>
  );
}

export default function HotRank() {
  return (
    <section id="hot-rank" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
              <i className="ri-fire-fill"></i> 每 10 分钟更新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热搜榜 · 热瓜排行
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              校园吃瓜爆料墙上的当红话题，按围观热度实时排序。
            </p>
          </div>
        </div>

        <ol className="mt-8 grid gap-4 md:grid-cols-2">
          {hotRank.map((item) => (
            <li
              key={item.rank}
              className="group flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 shadow-soft transition hover:-translate-y-0.5 hover:shadow-lift md:p-5"
            >
              <div className="flex flex-col items-center">
                <span
                  className={`font-heading text-3xl font-black leading-none ${
                    item.rank <= 3
                      ? "text-primary-600"
                      : "text-foreground-300"
                  }`}
                >
                  {String(item.rank).padStart(2, "0")}
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`whitespace-nowrap rounded-md px-1.5 py-0.5 text-[10px] font-medium ${
                      item.category === "暖闻"
                        ? "bg-accent-100 text-accent-800"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.category}
                  </span>
                  <span className="rounded-md bg-primary-100 px-1.5 py-0.5 text-[10px] font-bold text-primary-700">
                    {item.hotTag}
                  </span>
                </div>
                <h3 className="mt-2 text-sm font-medium leading-relaxed text-foreground-950 transition group-hover:text-primary-700 md:text-[15px]">
                  {item.title}
                </h3>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {(item.heat / 1000).toFixed(1)}k 围观
                  </span>
                  <Trend delta={item.delta} />
                </div>
              </div>
              <div className="hidden w-16 shrink-0 flex-col items-end justify-between sm:flex">
                <span className="text-[10px] text-foreground-400">热度</span>
                <div className="h-24 w-2 overflow-hidden rounded-full bg-background-200">
                  <div
                    className="w-full rounded-full bg-gradient-to-t from-primary-500 to-primary-400"
                    style={{
                      height: `${Math.max(18, (item.heat / maxHeat) * 100)}%`,
                    }}
                  ></div>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}